import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icons/price.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-8f9d2b08"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "productDetails" };
var _hoisted_2 = { class: "back" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", null, "首页", -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", null, "产品中心", -1); });
var _hoisted_5 = { class: "productType" };
var _hoisted_6 = { class: "product_details_carousel" };
var _hoisted_7 = { class: "details_img" };
var _hoisted_8 = { style: { "margin-top": "150px" } };
var _hoisted_9 = { style: { "line-height": "1.8", "padding-top": "20px" } };
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("h4", null, "产品描述", -1); });
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = { class: "selectButton" };
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("a", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "价格咨询"),
        /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 })
    ])
], -1); });
var _hoisted_14 = [
    _hoisted_13
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_Nav = _resolveComponent("Nav");
    var _component_HomeJumbotron = _resolveComponent("HomeJumbotron");
    var _component_el_col = _resolveComponent("el-col");
    var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
    var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
    var _component_el_carousel_item = _resolveComponent("el-carousel-item");
    var _component_el_carousel = _resolveComponent("el-carousel");
    var _component_el_row = _resolveComponent("el-row");
    var _component_BasisGroup = _resolveComponent("BasisGroup");
    var _component_Dialog = _resolveComponent("Dialog");
    var _directive_lazy = _resolveDirective("lazy");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Nav, { navActiveIndex: _ctx.navActiveIndex }, null, 8, ["navActiveIndex"]),
        _createVNode(_component_HomeJumbotron),
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_row, null, {
                default: _withCtx(function () { return [
                    _createVNode(_component_el_col, {
                        md: 4,
                        xs: 1
                    }),
                    _createVNode(_component_el_col, {
                        md: 16,
                        xs: 22
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                                            default: _withCtx(function () { return [
                                                _hoisted_3
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_breadcrumb_item, { to: { path: '/productInformation/productCategory' } }, {
                                            default: _withCtx(function () { return [
                                                _hoisted_4
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_breadcrumb_item, null, {
                                            default: _withCtx(function () { return [
                                                _createTextVNode("产品详情")
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_row, null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_col, { span: 24 }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", _hoisted_6, [
                                                    _createElementVNode("h2", null, _toDisplayString(_ctx.productInfo.productName), 1),
                                                    _createVNode(_component_el_carousel, {
                                                        interval: 5000,
                                                        arrow: "always"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productImg, function (item) {
                                                                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                                                                    default: _withCtx(function () { return [
                                                                        _createElementVNode("div", _hoisted_7, [
                                                                            _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                                                                                [_directive_lazy, item.productImg]
                                                                            ])
                                                                        ])
                                                                    ]; }),
                                                                    _: 2
                                                                }, 1024));
                                                            }), 128))
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createElementVNode("div", _hoisted_9, [
                                                        _hoisted_10,
                                                        _createElementVNode("p", {
                                                            style: { "text-align": "justify" },
                                                            innerHTML: _ctx.productInfo.productDesc
                                                        }, null, 8, _hoisted_11)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createElementVNode("p", {
                                                            class: "inquirPrice",
                                                            onClick: _cache[0] || (_cache[0] =
                                                                //@ts-ignore
                                                                function () {
                                                                    var args = [];
                                                                    for (var _i = 0; _i < arguments.length; _i++) {
                                                                        args[_i] = arguments[_i];
                                                                    }
                                                                    return (_ctx.tipShow && _ctx.tipShow.apply(_ctx, args));
                                                                })
                                                        }, _hoisted_14)
                                                    ])
                                                ])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            })
        ]),
        _createVNode(_component_BasisGroup),
        _createVNode(_component_Dialog, {
            dialogVisible: _ctx.dialogVisible,
            onClose: _ctx.close
        }, null, 8, ["dialogVisible", "onClose"])
    ], 64));
}
